// Generated by Melange

import * as Caml_exceptions from "melange.js/caml_exceptions.js";
import * as Caml_format from "melange.js/caml_format.js";
import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as Js__Js_dict from "melange.js/js_dict.js";
import * as Js__Js_json from "melange.js/js_json.js";
import * as Json__Json_decode from "melange-json/Json_decode.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__Array from "melange/array.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__String from "melange/string.js";

const DecodeErrorPath = /* @__PURE__ */ Caml_exceptions.create("Atdgen_codec_decode.DecodeErrorPath");

function make(f) {
  return f;
}

function decode(f, json) {
  try {
    return Curry._1(f, json);
  }
  catch (raw_exn){
    const exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
    if (exn.MEL_EXN_ID === DecodeErrorPath) {
      const path = Stdlib__String.concat(".", exn._1);
      throw new Caml_js_exceptions.MelangeError(Json__Json_decode.DecodeError, {
            MEL_EXN_ID: Json__Json_decode.DecodeError,
            _1: "" + path + ": " + exn._2
          });
    }
    throw new Caml_js_exceptions.MelangeError(exn.MEL_EXN_ID, exn);
  }
}

function with_segment(segment, f, json) {
  try {
    return Curry._1(f, json);
  }
  catch (raw_msg){
    const msg = Caml_js_exceptions.internalToOCamlException(raw_msg);
    if (msg.MEL_EXN_ID === Json__Json_decode.DecodeError) {
      throw new Caml_js_exceptions.MelangeError(DecodeErrorPath, {
            MEL_EXN_ID: DecodeErrorPath,
            _1: {
              hd: segment,
              tl: /* [] */ 0
            },
            _2: msg._1
          });
    }
    if (msg.MEL_EXN_ID === DecodeErrorPath) {
      throw new Caml_js_exceptions.MelangeError(DecodeErrorPath, {
            MEL_EXN_ID: DecodeErrorPath,
            _1: {
              hd: segment,
              tl: msg._1
            },
            _2: msg._2
          });
    }
    throw new Caml_js_exceptions.MelangeError(msg.MEL_EXN_ID, msg);
  }
}

function unit(j) {
  if (Js__Js_json.test(j, /* Null */ 5)) {
    return;
  }
  throw new Caml_js_exceptions.MelangeError(Json__Json_decode.DecodeError, {
        MEL_EXN_ID: Json__Json_decode.DecodeError,
        _1: "Expected null, got " + JSON.stringify(j)
      });
}

function int32(j) {
  return Caml_format.caml_int32_of_string(Json__Json_decode.string(j));
}

function int64(j) {
  return Caml_format.caml_int64_of_string(Json__Json_decode.string(j));
}

function array(decode, json) {
  if (Array.isArray(json)) {
    const length = json.length;
    const target = new Array(length);
    for (let i = 0; i < length; ++i) {
      let value;
      try {
        value = with_segment(String(i), decode, json[i]);
      }
      catch (raw_msg){
        const msg = Caml_js_exceptions.internalToOCamlException(raw_msg);
        if (msg.MEL_EXN_ID === Json__Json_decode.DecodeError) {
          throw new Caml_js_exceptions.MelangeError(Json__Json_decode.DecodeError, {
                MEL_EXN_ID: Json__Json_decode.DecodeError,
                _1: msg._1 + ("\n\tin array at index " + String(i))
              });
        }
        throw new Caml_js_exceptions.MelangeError(msg.MEL_EXN_ID, msg);
      }
      target[i] = value;
    }
    return target;
  }
  throw new Caml_js_exceptions.MelangeError(Json__Json_decode.DecodeError, {
        MEL_EXN_ID: Json__Json_decode.DecodeError,
        _1: "Expected array, got " + JSON.stringify(json)
      });
}

function list(decode, json) {
  return Stdlib__Array.to_list(array(decode, json));
}

function pair(decodeA, decodeB, json) {
  if (Array.isArray(json)) {
    const length = json.length;
    if (length === 2) {
      try {
        return [
          with_segment("0", decodeA, json[0]),
          with_segment("1", decodeB, json[1])
        ];
      }
      catch (raw_msg){
        const msg = Caml_js_exceptions.internalToOCamlException(raw_msg);
        if (msg.MEL_EXN_ID === Json__Json_decode.DecodeError) {
          throw new Caml_js_exceptions.MelangeError(Json__Json_decode.DecodeError, {
                MEL_EXN_ID: Json__Json_decode.DecodeError,
                _1: msg._1 + "\n\tin pair/tuple2"
              });
        }
        throw new Caml_js_exceptions.MelangeError(msg.MEL_EXN_ID, msg);
      }
    } else {
      const length_str = String(length);
      throw new Caml_js_exceptions.MelangeError(Json__Json_decode.DecodeError, {
            MEL_EXN_ID: Json__Json_decode.DecodeError,
            _1: "Expected array of length 2, got array of length " + length_str
          });
    }
  } else {
    throw new Caml_js_exceptions.MelangeError(Json__Json_decode.DecodeError, {
          MEL_EXN_ID: Json__Json_decode.DecodeError,
          _1: "Expected array, got " + JSON.stringify(json)
        });
  }
}

function tuple3(decodeA, decodeB, decodeC, json) {
  if (Array.isArray(json)) {
    const length = json.length;
    if (length === 3) {
      try {
        return [
          with_segment("0", decodeA, json[0]),
          with_segment("1", decodeB, json[1]),
          with_segment("2", decodeC, json[2])
        ];
      }
      catch (raw_msg){
        const msg = Caml_js_exceptions.internalToOCamlException(raw_msg);
        if (msg.MEL_EXN_ID === Json__Json_decode.DecodeError) {
          throw new Caml_js_exceptions.MelangeError(Json__Json_decode.DecodeError, {
                MEL_EXN_ID: Json__Json_decode.DecodeError,
                _1: msg._1 + "\n\tin tuple3"
              });
        }
        throw new Caml_js_exceptions.MelangeError(msg.MEL_EXN_ID, msg);
      }
    } else {
      const length_str = String(length);
      throw new Caml_js_exceptions.MelangeError(Json__Json_decode.DecodeError, {
            MEL_EXN_ID: Json__Json_decode.DecodeError,
            _1: "Expected array of length 3, got array of length " + length_str
          });
    }
  } else {
    throw new Caml_js_exceptions.MelangeError(Json__Json_decode.DecodeError, {
          MEL_EXN_ID: Json__Json_decode.DecodeError,
          _1: "Expected array, got " + JSON.stringify(json)
        });
  }
}

function tuple4(decodeA, decodeB, decodeC, decodeD, json) {
  if (Array.isArray(json)) {
    const length = json.length;
    if (length === 4) {
      try {
        return [
          with_segment("1", decodeA, json[0]),
          with_segment("2", decodeB, json[1]),
          with_segment("3", decodeC, json[2]),
          with_segment("4", decodeD, json[3])
        ];
      }
      catch (raw_msg){
        const msg = Caml_js_exceptions.internalToOCamlException(raw_msg);
        if (msg.MEL_EXN_ID === Json__Json_decode.DecodeError) {
          throw new Caml_js_exceptions.MelangeError(Json__Json_decode.DecodeError, {
                MEL_EXN_ID: Json__Json_decode.DecodeError,
                _1: msg._1 + "\n\tin tuple4"
              });
        }
        throw new Caml_js_exceptions.MelangeError(msg.MEL_EXN_ID, msg);
      }
    } else {
      const length_str = String(length);
      throw new Caml_js_exceptions.MelangeError(Json__Json_decode.DecodeError, {
            MEL_EXN_ID: Json__Json_decode.DecodeError,
            _1: "Expected array of length 4, got array of length " + length_str
          });
    }
  } else {
    throw new Caml_js_exceptions.MelangeError(Json__Json_decode.DecodeError, {
          MEL_EXN_ID: Json__Json_decode.DecodeError,
          _1: "Expected array, got " + JSON.stringify(json)
        });
  }
}

function dict(decode, json) {
  if (Js__Js_json.test(json, /* Object */ 2)) {
    const keys = Object.keys(json);
    const l = keys.length;
    const target = {};
    for (let i = 0; i < l; ++i) {
      const key = keys[i];
      let value;
      try {
        value = with_segment(key, decode, json[key]);
      }
      catch (raw_msg){
        const msg = Caml_js_exceptions.internalToOCamlException(raw_msg);
        if (msg.MEL_EXN_ID === Json__Json_decode.DecodeError) {
          throw new Caml_js_exceptions.MelangeError(Json__Json_decode.DecodeError, {
                MEL_EXN_ID: Json__Json_decode.DecodeError,
                _1: msg._1 + "\n\tin dict"
              });
        }
        throw new Caml_js_exceptions.MelangeError(msg.MEL_EXN_ID, msg);
      }
      target[key] = value;
    }
    return target;
  }
  throw new Caml_js_exceptions.MelangeError(Json__Json_decode.DecodeError, {
        MEL_EXN_ID: Json__Json_decode.DecodeError,
        _1: "Expected object, got " + JSON.stringify(json)
      });
}

function field(key, decode, json) {
  if (Js__Js_json.test(json, /* Object */ 2)) {
    const value = Js__Js_dict.get(json, key);
    if (value !== undefined) {
      try {
        return with_segment(key, decode, Caml_option.valFromOption(value));
      }
      catch (raw_msg){
        const msg = Caml_js_exceptions.internalToOCamlException(raw_msg);
        if (msg.MEL_EXN_ID === Json__Json_decode.DecodeError) {
          throw new Caml_js_exceptions.MelangeError(Json__Json_decode.DecodeError, {
                MEL_EXN_ID: Json__Json_decode.DecodeError,
                _1: msg._1 + ("\n\tat field '" + (key + "'"))
              });
        }
        throw new Caml_js_exceptions.MelangeError(msg.MEL_EXN_ID, msg);
      }
    } else {
      throw new Caml_js_exceptions.MelangeError(Json__Json_decode.DecodeError, {
            MEL_EXN_ID: Json__Json_decode.DecodeError,
            _1: "Expected field '" + key + "'"
          });
    }
  } else {
    throw new Caml_js_exceptions.MelangeError(Json__Json_decode.DecodeError, {
          MEL_EXN_ID: Json__Json_decode.DecodeError,
          _1: "Expected object, got " + JSON.stringify(json)
        });
  }
}

function obj_array(f, json) {
  return Js__Js_dict.entries(dict(f, json));
}

function obj_list(f, json) {
  return Stdlib__Array.to_list(obj_array(f, json));
}

function nullable(decode, json) {
  if (Js__Js_json.test(json, /* Null */ 5)) {
    return;
  } else {
    return Caml_option.some(Curry._1(decode, json));
  }
}

function fieldOptional(key, decode, json) {
  if (Js__Js_json.test(json, /* Object */ 2)) {
    const value = Js__Js_dict.get(json, key);
    if (value === undefined) {
      return;
    }
    const value$1 = Caml_option.valFromOption(value);
    if (Js__Js_json.test(value$1, /* Null */ 5)) {
      return;
    }
    try {
      return Caml_option.some(with_segment(key, decode, value$1));
    }
    catch (raw_msg){
      const msg = Caml_js_exceptions.internalToOCamlException(raw_msg);
      if (msg.MEL_EXN_ID === Json__Json_decode.DecodeError) {
        throw new Caml_js_exceptions.MelangeError(Json__Json_decode.DecodeError, {
              MEL_EXN_ID: Json__Json_decode.DecodeError,
              _1: msg._1 + ("\n\tat field '" + (key + "'"))
            });
      }
      throw new Caml_js_exceptions.MelangeError(msg.MEL_EXN_ID, msg);
    }
  } else {
    throw new Caml_js_exceptions.MelangeError(Json__Json_decode.DecodeError, {
          MEL_EXN_ID: Json__Json_decode.DecodeError,
          _1: "Expected object, got " + JSON.stringify(json)
        });
  }
}

function fieldDefault(s, $$default, f) {
  return function (param) {
    return Json__Json_decode.map((function (s) {
      if (s !== undefined) {
        return Caml_option.valFromOption(s);
      } else {
        return $$default;
      }
    }), (function (param) {
      return fieldOptional(s, f, param);
    }), param);
  };
}

function tuple1(f, x) {
  if (Array.isArray(x)) {
    const length = x.length;
    if (length === 1) {
      try {
        return with_segment("0", f, x[0]);
      }
      catch (raw_msg){
        const msg = Caml_js_exceptions.internalToOCamlException(raw_msg);
        if (msg.MEL_EXN_ID === Json__Json_decode.DecodeError) {
          throw new Caml_js_exceptions.MelangeError(Json__Json_decode.DecodeError, {
                MEL_EXN_ID: Json__Json_decode.DecodeError,
                _1: msg._1 + "\n\tin tuple1"
              });
        }
        throw new Caml_js_exceptions.MelangeError(msg.MEL_EXN_ID, msg);
      }
    } else {
      const length_str = String(length);
      throw new Caml_js_exceptions.MelangeError(Json__Json_decode.DecodeError, {
            MEL_EXN_ID: Json__Json_decode.DecodeError,
            _1: "Expected array of length 1, got array of length " + length_str
          });
    }
  } else {
    throw new Caml_js_exceptions.MelangeError(Json__Json_decode.DecodeError, {
          MEL_EXN_ID: Json__Json_decode.DecodeError,
          _1: "Expected array, got " + JSON.stringify(x)
        });
  }
}

function $$enum(l, json) {
  const constr0 = function (j) {
    const s = Json__Json_decode.string(j);
    return {
      NAME: "Constr0",
      VAL: s
    };
  };
  const constr = function (j) {
    const p = pair(Json__Json_decode.string, (function (x) {
      return x;
    }), j);
    return {
      NAME: "Constr",
      VAL: p
    };
  };
  const match = Json__Json_decode.either(constr0, constr)(json);
  if (match.NAME === "Constr") {
    const match$1 = match.VAL;
    const args = match$1[1];
    const s = match$1[0];
    return with_segment(s, (function (param) {
      let val;
      try {
        val = Stdlib__List.assoc(s, l);
      }
      catch (raw_exn){
        const exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
        if (exn.MEL_EXN_ID === Stdlib.Not_found) {
          throw new Caml_js_exceptions.MelangeError(Json__Json_decode.DecodeError, {
                MEL_EXN_ID: Json__Json_decode.DecodeError,
                _1: "unknown constructor \"" + s + "\""
              });
        }
        throw new Caml_js_exceptions.MelangeError(exn.MEL_EXN_ID, exn);
      }
      if (val.NAME === "Decode") {
        return Curry._1(val.VAL, args);
      }
      throw new Caml_js_exceptions.MelangeError(Json__Json_decode.DecodeError, {
            MEL_EXN_ID: Json__Json_decode.DecodeError,
            _1: "constructor \"" + s + "\" doesn't expect arguments"
          });
    }), undefined);
  }
  const s$1 = match.VAL;
  return with_segment(s$1, (function (param) {
    let val;
    try {
      val = Stdlib__List.assoc(s$1, l);
    }
    catch (raw_exn){
      const exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
      if (exn.MEL_EXN_ID === Stdlib.Not_found) {
        throw new Caml_js_exceptions.MelangeError(Json__Json_decode.DecodeError, {
              MEL_EXN_ID: Json__Json_decode.DecodeError,
              _1: "unknown constructor \"" + s$1 + "\""
            });
      }
      throw new Caml_js_exceptions.MelangeError(exn.MEL_EXN_ID, exn);
    }
    if (val.NAME === "Decode") {
      throw new Caml_js_exceptions.MelangeError(Json__Json_decode.DecodeError, {
            MEL_EXN_ID: Json__Json_decode.DecodeError,
            _1: "constructor \"" + s$1 + "\" expects arguments"
          });
    }
    return val.VAL;
  }), undefined);
}

function option_as_constr(f) {
  return Json__Json_decode.either((function (x) {
    if (Json__Json_decode.string(x) === "None") {
      return;
    }
    throw new Caml_js_exceptions.MelangeError(Json__Json_decode.DecodeError, {
          MEL_EXN_ID: Json__Json_decode.DecodeError,
          _1: "Expected None, got " + JSON.stringify(x)
        });
  }), (function (x) {
    const match = pair(Json__Json_decode.string, f, x);
    if (match[0] === "Some") {
      return Caml_option.some(match[1]);
    }
    throw new Caml_js_exceptions.MelangeError(Json__Json_decode.DecodeError, {
          MEL_EXN_ID: Json__Json_decode.DecodeError,
          _1: "Expected Some _, got " + JSON.stringify(x)
        });
  }));
}

function adapter(normalize, reader, json) {
  return Curry._1(reader, Curry._1(normalize, json));
}

const bool = Json__Json_decode.bool;

const $$int = Json__Json_decode.$$int;

const $$float = Json__Json_decode.$$float;

const $$char = Json__Json_decode.$$char;

const string = Json__Json_decode.string;

const optional = Json__Json_decode.optional;

const map = Json__Json_decode.map;

const tuple2 = pair;

export {
  DecodeErrorPath,
  make,
  decode,
  unit,
  bool,
  $$int,
  $$float,
  $$char,
  string,
  int32,
  int64,
  optional,
  list,
  array,
  obj_list,
  obj_array,
  field,
  fieldDefault,
  fieldOptional,
  map,
  tuple1,
  tuple2,
  tuple3,
  tuple4,
  $$enum,
  nullable,
  option_as_constr,
  adapter,
}
/* No side effect */
